var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "w100" },
    [
      _c("w-breadcrumb", { attrs: { crumbs: _vm.path } }),
      _c(
        "w-scroll-view",
        { attrs: { tag: "w-container" } },
        [
          _c(
            "w-row",
            { attrs: { "no-margin": "" } },
            [
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c(
                    "w-card",
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("general")))]),
                      _c(
                        "w-sortable",
                        {
                          attrs: {
                            items: _vm.statuses,
                            tag: "w-list",
                            "disable-x": "",
                            "target-class": "handle",
                          },
                          on: {
                            drop: function ($event) {
                              return _vm.onSorted()
                            },
                          },
                        },
                        [
                          _vm._l(_vm.statuses, function (item) {
                            return _c(
                              "w-list-item",
                              { key: item.ID, attrs: { "show-handle": "" } },
                              [
                                _c("w-list-item-text", [
                                  _c("div", [
                                    _vm._v(" " + _vm._s(item.Name) + " "),
                                  ]),
                                ]),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.edit"),
                                            expression: "$ct('common.edit')",
                                          },
                                        ],
                                        on: {
                                          click: function ($event) {
                                            return _vm.editStatus(item)
                                          },
                                        },
                                      },
                                      [_c("w-fa", { attrs: { icon: "pen" } })],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "w-list-item-action",
                                  [
                                    _c(
                                      "w-button",
                                      {
                                        directives: [
                                          {
                                            name: "tooltip",
                                            rawName: "v-tooltip",
                                            value: _vm.$ct("common.delete"),
                                            expression: "$ct('common.delete')",
                                          },
                                        ],
                                        staticClass: "danger",
                                        on: {
                                          click: function ($event) {
                                            return _vm.deleteStatus(item)
                                          },
                                        },
                                      },
                                      [
                                        _c("w-fa", {
                                          attrs: { icon: "trash" },
                                        }),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          }),
                          _c(
                            "w-list-item",
                            { on: { click: _vm.openNewModal } },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "plus" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(
                                  " " + _vm._s(_vm.$ct("common.add")) + " "
                                ),
                              ]),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "w-col",
                { attrs: { xs: "12", lg: "6" } },
                [
                  _c("app-crm-calendar-fields-settings", {
                    attrs: {
                      fields: _vm.crmSettings.CalendarToShowFields,
                      title: _vm.$ct("calendar-field-values"),
                    },
                    on: {
                      changed: function ($event) {
                        return _vm.saveCrmSettings()
                      },
                    },
                  }),
                  _c("app-crm-calendar-fields-settings", {
                    staticClass: "mt",
                    attrs: {
                      fields: _vm.crmSettings.CalendarToShowHoverFields,
                      title: _vm.$ct("calendar-hover-field-values"),
                    },
                    on: {
                      changed: function ($event) {
                        return _vm.saveCrmSettings()
                      },
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-modal",
            { attrs: { value: _vm.toEditStatus != null } },
            [
              _vm.toEditStatus
                ? _c(
                    "w-card",
                    { attrs: { "max-width": "700" } },
                    [
                      _c("w-card-title", [_vm._v(_vm._s(_vm.modalTitle))]),
                      _c(
                        "w-card-content",
                        [
                          _c(
                            "w-row",
                            [
                              _c(
                                "w-col",
                                { attrs: { xs: "12", md: "12" } },
                                [
                                  _c("w-input", {
                                    attrs: {
                                      fancy: "",
                                      label: _vm.$ct("common.name"),
                                    },
                                    model: {
                                      value: _vm.toEditStatus.Name,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.toEditStatus, "Name", $$v)
                                      },
                                      expression: "toEditStatus.Name",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                      _c(
                        "w-card-actions",
                        [
                          _c(
                            "w-button",
                            {
                              staticClass: "cancel",
                              on: {
                                click: function ($event) {
                                  return _vm.cancelModal()
                                },
                              },
                            },
                            [
                              _vm._v(
                                " " + _vm._s(_vm.$ct("common.cancel")) + " "
                              ),
                            ]
                          ),
                          _c("w-spacer"),
                          _c(
                            "w-button",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.save()
                                },
                              },
                            },
                            [_vm._v(" " + _vm._s(_vm.$ct("common.save")) + " ")]
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }